import React from 'react';
import { Row, Col } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { List, Map } from 'immutable';
import { CompanyManagementForm } from './../../../components';
import {
  getCompanies,
  getCompanyActionResponse,
  getLoadingStatus,
} from './../../../selectors/Company';
import { getUser } from './../../../selectors/Authentication';
import { companyCreate, companyDelete, companyEdit } from '../../../actions/Company';
import { clearActionResponse } from './../../../actions/Global';

class CompanyManagement extends React.Component {
  render() {
    return (
      <Row>
        <Col span={24}>
          <CompanyManagementForm
            user={this.props.user}
            isLoading={this.props.isLoading}
            companyCreate={this.props.companyCreate}
            companyEdit={this.props.companyEdit}
            companyDelete={this.props.companyDelete}
            companies={this.props.companies}
            actionResponse={this.props.companyActionResponse}
            clearActionResponse={this.props.clearActionResponse}
          />
        </Col>
      </Row>
    );
  }
}

/**
 * Maps relevant store state to props for this component.
 * @param state to be handled
 * @returns {{user, companies, companyActionResponse}} are values returned or
 * manipulated from the state before sent to this component.
 */
const mapStateToProps = (state) => {
  return {
    isLoading: getLoadingStatus(state),
    user: getUser(state),
    companies: getCompanies(state),
    companyActionResponse: getCompanyActionResponse(state),
  };
};

/**
 * Maps relevant store actions to props for this component.
 * @param dispatch actions to be handled.
 * @returns {{companyCreate, companyEdit, companyDelete, clearActionResponse}}
 * are actions that are mapped to props for this component.
 */
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      companyCreate: companyCreate,
      companyEdit: companyEdit,
      companyDelete: companyDelete,
      clearActionResponse: clearActionResponse,
    },
    dispatch
  );
};

/**
 * Proptypes validates that the state props are of expected type.
 * @type {{user: shim, companies: shim, companyCreate: shim, companyEdit: shim, companyDelete: shim,
 * companyActionResponse: shim, clearActionResponse: shim}}
 */
CompanyManagement.propTypes = {
  user: PropTypes.instanceOf(Map),
  companies: PropTypes.instanceOf(List),
  companyCreate: PropTypes.func,
  companyEdit: PropTypes.func,
  companyDelete: PropTypes.func,
  companyActionResponse: PropTypes.object,
  clearActionResponse: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyManagement);
